<div class="sign-in-box-container ui-g">
  <div class="sign-in-box-inner-container">
    <div class="signin-box ui-g-10 ui-md-6 ui-lg-6 ui-g-nopad">
      <div class="company-logo">
        <img width="200" src="/assets/images/temp/header-logo.png">
      </div>

      <p-panel header="Sign In">
        <form [formGroup]='signInForm'>
          <div class="form-container ui-g">
            <div class="form-errors">
              <div [hidden]="!loginErrors.general.hasError" class="alert alert-danger">
                <div *ngFor="let ErrorMessage of loginErrors.general.error">
                  {{ErrorMessage.message}}
                </div>
              </div>
            </div>

            <div class="form-field ui-g-12 ui-g-nopad">
              <div class="form-label">
                <label for="username" translate>Username</label>
              </div>
              <div class="form-control">
                <input formControlName="username" type="text" pInputText (keypress)="eventHandler($event)" />
              </div>
              <div class="form-errors" *ngIf="signInForm.controls.username.errors  && (signInForm.controls.username.dirty || signInForm.controls.username.touched)">
                <div [hidden]="!signInForm.controls.username.errors.required">
                  {{'Username is required'}}
                </div>
              </div>
            </div>

            <div class="form-field ui-g-12 ui-g-nopad">
              <div class="form-label">
                <label for="passwd" translate> Passwords </label>
              </div>
              <div class="form-control">
                <input formControlName="password" type="password" (keypress)="eventHandler($event)" pInputText/>
                <div [hidden]="!loginErrors.password.hasError" class="alert alert-danger">
                  <div *ngFor="let ErrorMessage of loginErrors.password.error">
                    {{ErrorMessage.message}}
                  </div>
                </div>
              </div>
              <div class="form-errors" *ngIf="signInForm.controls.password.errors  && (signInForm.controls.password.dirty || signInForm.controls.password.touched)">
                <div [hidden]="!signInForm.controls.password.errors.required">
                  {{'Password is required'}}
                </div>
              </div>

              <div class="form-buttons ui-g-12 ui-g-nopad">
                <a (click)="forgotPassword()" translate>forgot_password</a>
                <button pButton label="Sign In" type="button" [disabled]="!signInForm.valid" (click)="doSignIn()"></button>
              </div>
            </div>
          </div>
        </form>
      </p-panel>

    </div>
  </div>
</div>


<p-dialog modal="false" styleClass="edit-popup" position="center center" responsive="true" [(visible)]="forgotPopup">
  <p-header>
    Forgot Password
  </p-header>
  <app-forgot-password (onPopClose)="onPopClose($event)" (onPopSave)="onPopSave($event)"></app-forgot-password>
</p-dialog>

<p-growl [value]="message"></p-growl>